module.exports = __webpack_public_path__ + "img/404.62dc566e.svg";